// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutUs_about__WwTrF","thankYou":"AboutUs_thankYou___SWUy"};